import React from 'react';
import {generateUtmTerm, trackShareLink} from '../services/SharingService';

export default function withTracking(WrappedComponent){
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.utmTerm = generateUtmTerm(this.props.utmTerm);

            this.trackShareLink = this.trackShareLink.bind(this);
        }

        trackShareLink(e) {
            trackShareLink(e, this.utmTerm, this.props.videoUrl);
        }

        render() {
            let props = Object.assign({}, this.props);
            props.trackShareLink = this.trackShareLink;
            props.utmTerm = this.utmTerm;

            return <WrappedComponent {...props} />
        }
    }
}
